import { type UUID } from '~/types/common';

import { type SupplierRequestState } from './types';

type SupplierRequestsQueryParams = {
  limit?: number;
  offset?: number;
  state?: SupplierRequestState;
};

export const queryKeysSupplierRequest = {
  base: () => 'supplierRequest' as const,
  get: (reqId: UUID | undefined) =>
    [queryKeysSupplierRequest.base(), 'detail', { reqId }] as const,
  getAll: (queryParams: SupplierRequestsQueryParams = {}) =>
    [queryKeysSupplierRequest.base(), 'list', 'admin', queryParams] as const,
} as const;
